import React, { useContext, useEffect, useState } from 'react';
import {Card, CardBody, Col, Container, Row} from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import DynamicForm from '../../../Components/DynamicForm';
import UiContent from "../../../Components/Common/UiContent";

const DenetimFormu = ({formId, standId, selectedData, activeFairId, documentTitle}) => {
    useEffect(() => {
        document.title = documentTitle ? documentTitle + " | Denetim Formu" : "FDS | Denetim Formu";
    }, [documentTitle]);
    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Denetim Formu" pageTitle={documentTitle} />
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <DynamicForm formId={formId} standId={standId} selectedData={selectedData} activeFairId={activeFairId}/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DenetimFormu;